import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { CallStatsHeatmapCell } from "@/services/callStatsService";

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const DISPLAY_ORDER = [1, 2, 3, 4, 5, 6, 0];
const HOURS = Array.from({ length: 24 }, (_, hour) => hour);

interface BusyHoursHeatmapProps {
  cells: CallStatsHeatmapCell[];
}

const BusyHoursHeatmap = ({ cells }: BusyHoursHeatmapProps) => {
  const counts = new Map(cells.map((cell) => [`${cell.dow}-${cell.hour}`, cell.calls]));
  const max = cells.reduce((acc, cell) => Math.max(acc, cell.calls), 0);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Busy hours</CardTitle>
      </CardHeader>
      <CardContent className="overflow-x-auto">
        <div
          className="grid min-w-[560px] gap-1 text-xs text-muted-foreground"
          style={{ gridTemplateColumns: "2.5rem repeat(24, minmax(0, 1fr))" }}
        >
          <div />
          {HOURS.map((hour) => (
            <div key={hour} className="text-center">
              {hour % 3 === 0 ? hour : ""}
            </div>
          ))}
          {DISPLAY_ORDER.map((dow) => (
            <div key={dow} className="contents">
              <div className="flex items-center">{DAYS[dow]}</div>
              {HOURS.map((hour) => {
                const calls = counts.get(`${dow}-${hour}`) ?? 0;
                return (
                  <div
                    key={hour}
                    title={`${DAYS[dow]} ${String(hour).padStart(2, "0")}:00 — ${calls} calls`}
                    className="aspect-square rounded-sm bg-muted"
                    style={
                      calls > 0
                        ? {
                            background: "var(--chart-1)",
                            opacity: 0.15 + 0.85 * (calls / max),
                          }
                        : undefined
                    }
                  />
                );
              })}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default BusyHoursHeatmap;
